import { IDict } from "./types";

export const ar: IDict = {
  Jobs: "وظائف",
  "No Jobs": "لا توجد وظائف",
  Billing: "الفواتير",
  Credits: "الرصيد",
  "Pay Per Use": "الدفع حسب الاستخدام",
  "Feature Voting": "التصويت على الميزات",
  "Free Karaoke Left": "الكاريوكي المجاني المتبقي",
  "Upgrade Now to Create More": "قم بالترقية الآن لإنشاء المزيد",
  "Storage is Full": "التخزين ممتلئ",
  "Youka is running out of storage space": "يوكا على وشك نفاد مساحة التخزين",
  "Please free up at least 1 GB before creating new karaoke":
    "يرجى تحرير مساحة لا تقل عن 1 جيجابايت قبل إنشاء كاريوكي جديد",
  "Click the button to check again": "انقر على الزر للتحقق مرة أخرى",
  "No Internet Connection": "لا يوجد اتصال بالإنترنت",
  "Youka cannot connect to the internet": "لا يمكن ليوكا الاتصال بالإنترنت",
  "Please make sure you have internet connection":
    "يرجى التأكد من وجود اتصال بالإنترنت",
  "Update is ready": "التحديث جاهز",
  "Click the button to update": "انقر على الزر لتحديث",
  "Library Folder": "مجلد المكتبة",
  "Export Folder": "مجلد التصدير",
  "Sync Model": "مزامنة النموذج",
  "Max Video Quality": "أقصى جودة للفيديو",
  "Speed / Compression Preset": "السرعة / الإعدادات المسبقة للضغط",
  Change: "تغيير",
  "dialogs.upgrade.upgrade_to_pro":
    "الميزة التي تبحث عنها جزء من خطة Pro، قم بالترقية الآن لفتح هذه الميزة.",
  "dialogs.upgrade.upgrade_to_standard":
    "الميزة التي تبحث عنها جزء من خطة Standard، قم بالترقية الآن لفتح هذه الميزة.",
  heads_up: "انتباه!",
  "dialogs.edit_lyrics.not_supported":
    "اللغة التي اخترتها غير مدعومة حاليًا للمزامنة التلقائية للكلمات. ومع ذلك، يمكنك حفظ تقدمك ثم استخدام محرر المستوى الخطي لمزامنة الكلمات يدويًا.",
  "dialogs.create.title": "إنشاء كاريوكي جديد",
  "dialogs.create.description":
    "يرجى ملء النموذج أدناه لإنشاء كاريوكي جديد، يمكنك استخدام ملف صوتي أو فيديو، الكلمات اختيارية.",
  "dialogs.edit_lyrics.description":
    "بعد الحفظ، ستبدأ عملية المزامنة، يمكنك متابعة التقدم في علامة تبويب الوظائف",
  "dialogs.upgrade.see_plans": "عرض الخطط",
  "dialogs.upgrade.unlock": "افتح",
  "comps.sync_editor.attach_previous": "ربط بالكلمة السابقة",
  "comps.sync_editor.attach_next": "ربط بالكلمة التالية",
  "comps.plans.title":
    "اختر الخطة التي تناسب احتياجاتك. يمكنك دائمًا الترقية أو الرجوع للخلف",
  "Font Size": "حجم الخط",
  Spacing: "التباعد",
  Outline: "الخط الخارجي",
  "Margin Bottom": "هامش أسفل",
  "Max Chars per Line": "أقصى عدد من الأحرف لكل سطر",
  Bold: "غامق",
  Italic: "مائل",
  Shadow: "ظل",
  month: "شهر",
  songs: "أغاني",
  Title: "العنوان",
  "Save and Sync": "حفظ ومزامنة",
  Lyrics: "الكلمات",
  Update: "تحديث",
  Playlist: "قائمة التشغيل",
  Canceling: "إلغاء",
  Play: "تشغيل",
  "Lyrics Language": "لغة الكلمات",
  "Background Image": "صورة الخلفية",
  "Basic Version": "الإصدار الأساسي",
  "Standard Version": "الإصدار القياسي",
  "Pro Version": "الإصدار الاحترافي",
  "Trial Version": "الإصدار التجريبي",
  "No Active Plan": "لا توجد خطة نشطة",
  "Days Left in Trial": "الأيام المتبقية في التجربة",
  Paste: "لصق",
  "Sync Lyrics": "مزامنة الكلمات",
  Show: "عرض",
  Settings: "الإعدادات",
  Retry: "إعادة المحاولة",
  "Create Karaoke": "إنشاء كاريوكي",
  Canceled: "تم الإلغاء",
  Reset: "إعادة تعيين",
  "Edit Video": "تعديل الفيديو",
  Download: "تنزيل",
  "Edit Metadata": "تحرير البيانات الوصفية",
  "Subtitle Designer": "مصمم الترجمة",
  Export: "تصدير",
  year: "سنة",
  Basic: "أساسي",
  Standard: "قياسي",
  Pro: "احترافي",
  Accept: "قبول",
  "Add new word": "إضافة كلمة جديدة",
  "Add to queue": "إضافة إلى القائمة",
  "An unknown error occurred": "حدث خطأ غير معروف",
  Annually: "سنوياً",
  "Are you sure you want to delete this karaoke song?":
    "هل أنت متأكد أنك تريد حذف هذه الأغنية الكاريوكي؟",
  "Artist Name": "اسم الفنان",
  "Audio or Video File": "ملف صوتي أو فيديو",
  Audio: "الصوت",
  "Auto Karaoke Generator": "مولد الكاريوكي التلقائي",
  "Auto Lyrics Sync": "مزامنة الكلمات التلقائية",
  "Cancel Plan": "إلغاء الخطة",
  Cancel: "إلغاء",
  Close: "إغلاق",
  "Create Karaoke from song": "إنشاء كاريوكي من الأغنية",
  "Create Karaoke from local files": "إنشاء كاريوكي من الملفات المحلية",
  "Create new karaoke": "إنشاء كاريوكي جديد",
  Create: "إنشاء",
  "Current Plan": "الخطة الحالية",
  "Dark Mode": "الوضع الداكن",
  Decline: "رفض",
  "Delete word": "حذف الكلمة",
  Delete: "حذف",
  "Edit Lyrics": "تعديل الكلمات",
  Edit: "تحرير",
  "Export to mp3/mp4": "تصدير إلى mp3/mp4",
  "Go Back to EULA": "العودة إلى اتفاقية الترخيص للمستخدم النهائي",
  "Go back": "العودة",
  "Go forward": "التقدم للأمام",
  Home: "الرئيسية",
  "I accept the terms and commit to avoiding unlicensed use of copyrighted content":
    "أقبل الشروط وألتزم بتجنب الاستخدام غير المرخص للمحتوى المحمي بحقوق النشر",
  Instruments: "الآلات",
  Library: "المكتبة",
  "Light Mode": "الوضع الفاتح",
  "Line Level Sync": "مزامنة مستوى السطر",
  "Line Level": "مستوى السطر",
  "Lyrics (optional)": "الكلمات (اختياري)",
  "Lyrics Sync Editor": "محرر مزامنة الكلمات",
  Manage: "إدارة",
  Monthly: "شهريًا",
  "Most popular": "الأكثر شيوعًا",
  "No new notifications": "لا توجد إشعارات جديدة",
  "No results": "لا توجد نتائج",
  "No songs in library": "لا توجد أغانٍ في المكتبة",
  "No songs in queue": "لا توجد أغانٍ في القائمة",
  Notifications: "الإشعارات",
  Off: "إيقاف",
  Or: "أو",
  "Plan canceled, will end in": "تم إلغاء الخطة، ستنتهي في",
  "Play word in loop": "تشغيل الكلمة في حلقة",
  "Preparing Youka": "تحضير يوكا",
  "Process 2 karaokes at a time": "معالجة 2 كاريوكي في وقت واحد",
  "Process 5 karaokes at a time": "معالجة 5 كاريوكي في وقت واحد",
  Queue: "القائمة",
  Ready: "جاهز",
  "Remove from queue": "إزالة من القائمة",
  "Resume plan": "استئناف الخطة",
  "Save and Resync": "حفظ وإعادة مزامنة",
  Save: "حفظ",
  "Saving...": "جارٍ الحفظ...",
  Search: "بحث",
  "Select plan": "اختر الخطة",
  "Sign In": "تسجيل الدخول",
  "Sign Out": "تسجيل الخروج",
  "Sign Up": "تسجيل",
  "Song Name": "اسم الأغنية",
  "Start typing to search or paste YouTube URL":
    "ابدأ بالكتابة للبحث أو الصق عنوان YouTube",
  "Start typing to search": "ابدأ بالكتابة للبحث",
  "Subtitle Track": "مسار الترجمة",
  Subtitles: "الترجمات",
  Tempo: "الإيقاع",
  "Terms and Conditions": "الشروط والأحكام",
  "This action cannot be undone.": "لا يمكن التراجع عن هذا الإجراء.",
  "Thumbnail URL": "عنوان URL للصورة المصغرة",
  "To keep the karaoke fun going, please upgrade":
    "للحفاظ على متعة الكاريوكي، يرجى الترقية",
  "Unlock Premium Features with an Upgrade!":
    "افتح الميزات المتميزة مع الترقية!",
  "Update Payment Method": "تحديث طريقة الدفع",
  "Upgrade to Pro plan to enable": "قم بالترقية إلى خطة Pro لتمكين",
  Upgrade: "ترقية",
  Version: "الإصدار",
  Video: "فيديو",
  Vocals: "الصوت",
  "Waiting in queue": "في انتظار القائمة",
  "Word Level Sync": "مزامنة مستوى الكلمة",
  "Word Level": "مستوى الكلمة",
  "You need to accept the EULA to use Youka":
    "تحتاج إلى قبول اتفاقية الترخيص للمستخدم النهائي لاستخدام يوكا",
  "Your lyrics have been saved successfully. A resync is currently in progress. You can monitor the progress in the notification area. Once the resync is complete, you'll be able to see the changes - just hit 'play'.":
    "تم حفظ كلماتك بنجاح. يجري حاليًا إعادة المزامنة. يمكنك متابعة التقدم في منطقة الإشعارات. بمجرد اكتمال إعادة المزامنة، ستتمكن من رؤية التغييرات - فقط اضغط على 'تشغيل'.",
  "Your trial version of Youka has expired":
    "انتهت صلاحية النسخة التجريبية من يوكا",
  "dialogs.youtube.title":
    "قم بتثبيت yt-dlp للبحث وتشغيل الفيديوهات عبر الإنترنت",
  "dialogs.youtube.description":
    "يرجى قراءة وقبول التحذيرات التالية قبل تمكين المكون الإضافي.",
  "dialogs.youtube.agree": "لقد قرأت وفهمت التحذيرات أعلاه",
  "dialogs.youtube.install": "تثبيت المكون الإضافي",
  "dialogs.youtube.install_success": "تم تثبيت المكون الإضافي بنجاح",
  "dialogs.youtube.install_success_description":
    "يمكنك الآن البحث وتشغيل الفيديوهات عبر الإنترنت",
  "dialogs.youtube.install_error": "فشل تثبيت المكون الإضافي",
  "alert.youtube.description":
    "المكون الإضافي للبحث وتنزيل الفيديوهات عبر الإنترنت (yt-dlp) غير مثبت مسبقًا. للتثبيت، يرجى النقر على زر 'تثبيت'.",
  "alert.youtube.install": "تثبيت المكون الإضافي",
  "dialogs.settings.enable_youtube": "تمكين المكون الإضافي yt-dlp",
  "dialogs.youtube.warnings": [
    {
      title: "الامتثال القانوني",
      description:
        "تأكد من أن استخدامك لهذا المكون الإضافي متوافق تمامًا مع جميع القوانين المعمول بها وشروط الخدمة لأي منصات تتعامل معها، مثل YouTube.",
    },
    {
      title: "حقوق الطبع والنشر والترخيص",
      description:
        "قد يسمح لك هذا المكون الإضافي باتخاذ إجراءات (مثل تنزيل المحتوى) قد تنتهك قوانين حقوق الطبع والنشر أو تنتهك اتفاقيات الترخيص إذا لم يتم استخدامها بشكل صحيح. من الضروري احترام حقوق منشئي المحتوى واستخدام المكون الإضافي فقط للأغراض القانونية.",
    },
    {
      title: "لا توجد تأييد",
      description:
        "تمكين هذا المكون الإضافي لا يعني تأييدًا أو دعمًا من قبل شركتنا. المكون الإضافي كيان منفصل ونحن غير مسؤولين عن تشغيله أو أي عواقب لاستخدامه.",
    },
    {
      title: "مسؤولية المستخدم",
      description:
        "أنت المسؤول الوحيد عن أي إجراءات تتخذها باستخدام هذا المكون الإضافي. يشمل ذلك أي عواقب قانونية قد تنشأ نتيجة سوء الاستخدام أو انتهاك شروط الخدمة.",
    },
    {
      title: "المخاطر المحتملة",
      description:
        "كن على علم بأن سوء استخدام المكون الإضافي قد يؤدي إلى تعليق الحساب أو اتخاذ إجراءات قانونية من الأطراف أو المنصات المتأثرة.",
    },
    {
      title: "الموافقة المستنيرة",
      description:
        "بالمضي قدمًا لتمكين هذا المكون الإضافي، فإنك تقر بأنك قد قرأت وفهمت هذه التحذيرات وتقبل المسؤولية الكاملة عن استخدامك للمكون الإضافي.",
    },
  ],
  "model.auto": "حدد أفضل نموذج تلقائيًا.",
  "model.audioshake.transcription":
    "النموذج الأول الأفضل، والذي يتضمن النسخ ثم المحاذاة، يقدم نتائج ممتازة ولكنه متاح حصريًا لمستخدمي الدفع حسب الاستخدام والمستخدمين التجريبيين (يستغرق حتى 10 دقائق).",
  "model.audioshake":
    "النموذج الثاني الأفضل، يطابق الكلمات المقدمة، حيث يمكن أن تؤدي الأخطاء إلى نتائج دون المستوى الأمثل (يستغرق حتى 10 دقائق).",
  "model.wav2vec2":
    "النموذج الثالث الأفضل، يطابق الكلمات المقدمة، حيث يمكن أن تؤدي الأخطاء إلى نتائج دون المستوى الأمثل، يدعم معظم اللغات. (يستغرق حتى 30 ثانية)",
  "model.whisper":
    "النموذج الرابع الأفضل، والذي يتضمن النسخ ثم المحاذاة. قد لا تكون الكلمات المنتجة دقيقة، ولكن التزامن مقبول (يستغرق حتى دقيقتين).",
  "sync.line.instructions": [
    "انقر على زر التشغيل لتشغيل الأغنية وبدء عملية المزامنة",
    "انقر على زر تعيين البداية عندما تسمع الكلمة الأولى من السطر الحالي",
    "انقر على زر تعيين النهاية بعد سماع الكلمة الأخيرة من السطر الحالي",
    "استمر حتى تنتهي من مزامنة جميع السطور",
  ],
  Undo: "تراجع",
  Redo: "إعادة",
  "Set Start": "تعيين البداية",
  "Set End": "تعيين النهاية",
  "dialogs.edit_lyrics.transcription":
    "عند استخدام نموذج النسخ، يقوم النموذج بنسخ الأغنية وتحديد الكلمات بمفرده، دون الاعتماد على أي كلمات مقدمة. بعد ذلك، لديك الخيار لضبط الكلمات باستخدام أداة المزامنة.",
  "Duet Editor": "محرر الدويت",
  "Manual Line Sync": "مزامنة السطر يدويًا",
  "New Style": "أسلوب جديد",
  Style: "أسلوب",
  Singer: "مغني",
  "Style Editor": "محرر الأسلوب",
  Word: "كلمة",
  Line: "سطر",
  "Split Line": "تقسيم السطر",
  "Upgrade to Enable": "ترقية لتمكين",
  upgrade_description:
    "لديك خيار الاستماع إلى أو تنزيل مسارات الكاريوكي التي قمت بإنشائها بالفعل. ومع ذلك، إذا كنت ترغب في إنشاء مسارات كاريوكي إضافية، يتطلب ذلك الترقية.",
  "dialogs.global.no_user.title": "لا توجد خطة نشطة",
  "dialogs.global.no_user.description": "يرجى الترقية إلى خطة للاستمرار",
  "dialogs.global.no_role.title": "لا توجد خطة نشطة",
  "dialogs.global.no_role.description": "يرجى الترقية إلى خطة للاستمرار",
  "dialogs.global.blocked_ip.title": "تم حظر عنوان IP الخاص بك",
  "dialogs.global.blocked_ip.description": "يرجى الاتصال بالدعم",
  "dialogs.global.rate_limit.title": "تم تجاوز الحد الأقصى",
  "dialogs.global.rate_limit.description":
    "يمكنك التحويل إلى خطة الدفع حسب الاستخدام للوصول غير المحدود.",
  "dialogs.global.disk_full.title": "التخزين ممتلئ",
  "dialogs.global.disk_full.description":
    "يرجى تحرير بعض المساحة للاستمرار في استخدام يوكا",
  "dialogs.global.too_big.title": "يتجاوز حجم ملف الصوت الحد المسموح به",
  "dialogs.global.too_big.description":
    "يرجى ملاحظة أن ملف الصوت لا يمكن أن يتجاوز الحد الأقصى لمدة 15 دقيقة.",
  Help: "مساعدة",
  Original: "الأصلي",
  Sort: "ترتيب",
  "sort.date.asc": "تاريخ الإنشاء (الأقدم إلى الأحدث)",
  "sort.date.desc": "تاريخ الإنشاء (الأحدث إلى الأقدم)",
  "sort.title.asc": "العنوان (من أ إلى ي)",
  "sort.title.desc": "العنوان (من ي إلى أ)",
  "dialogs.trim.title": "قص",
  "dialogs.trim.description":
    "استخدم الحدود القابلة للتعديل على الموجة الصوتية لاختيار الجزء من الأغنية الذي تريد الاحتفاظ به.",
  Start: "بداية",
  End: "نهاية",
  Time: "الوقت",
  Related: "مرتبط",
  preserve_vocals: "الحفاظ على الصوتيات",
  preserve_vocals_description: "قم بتبديل هذا للحفاظ على الصوتيات مثل الكورال.",
  "Separate Audio": "فصل الصوت",
  "Separate Model": "نموذج الفصل",
  "Add Lyrics": "إضافة كلمات",
  "Background Image or Video": "صورة أو فيديو الخلفية",
  Docs: "الوثائق",
  Watch: "شاهد",
  Hide: "إخفاء",
  "watch.sync.title": "كيفية إصلاح مزامنة الكلمات بسهولة؟",
  "watch.sync.url": "https://www.youtube.com/watch?v=kEHzfAwQBzo",
  Review: "مراجعة",
  "watch.review.title": "مراجعة Youka على Trustpilot",
  "Import Subtitles": "استيراد الترجمات",
  Import: "استيراد",
  "How to use": "كيفية الاستخدام",
  Uppercase: "الأبجدية",
  "Open Dual Screen": "فتح الشاشة المزدوجة",
  "Close Dual Screen": "إغلاق الشاشة المزدوجة",
  "Import Karaoke File": "استيراد ملف كاريوكي",
  "dialogs.import_karaoke.title": "استيراد الكاريوكي من ملف",
  "dialogs.import_karaoke.description":
    "استيراد ملف فيديو أو صوتي وملف LRC لإنشاء كاريوكي.",
  optional: "اختياري",
  "Trial Expired": "انتهت صلاحية الاختبار",
  "Subtitles Settings": "إعدادات الترجمات",
  Milliseconds: "مللي ثانية",
  Seconds: "ثواني",
  Text: "النص",
  Enabled: "مفعل",
  Duration: "المدة",
  Gap: "الفجوة",
  Offset: "التحريك",
  "Min Duration": "المدة الأقصر",
  "Max Duration": "المدة الأطول",
  "Fade In": "تدريج الصوت",
  "Fade Out": "تدريج الصوت",
  "plugins.title.title": "عنوان الأغنية",
  "plugins.title.description": "أدخل عنوان الأغنية في بداية الفيديو",
  "plugins.gap_text.title": "نص الفجوة",
  "plugins.gap_text.description": "أدخل النص في الفجوة بين الترجمات",
  "plugins.gap_progress_bar.title": "شريط التقدم في الفجوة",
  "plugins.gap_progress_bar.description":
    "أدخل شريط تقدم في الفجوة بين الترجمات",
  "plugins.fade.title": "تأثير التدريج",
  "plugins.fade.description": "أضف تأثير تدريج الصوت إلى الترجمات",
  "plugins.offset.title": "التحريك",
  "plugins.offset.description": "تحريك الترجمات بكمية معينة من الثواني",
  "plugins.countdown.title": "العد العكسي",
  "plugins.countdown.description": "أدخل عدد عكسي في الفجوة بين الترجمات",
  Auto: "تلقائي",
  Subword: "كلمة جزئية",
  Countdown: "العد العكسي",
  "Restart required": "يتطلب إعادة تشغيل",
  "Reindex Library": "إعادة ترتيب المكتبة",
  "Create playlist": "إنشاء قائمة",
  "Are you sure you want to delete?": "هل أنت متأكد من حذف؟",
  "Add to playlist": "إضافة إلى القائمة",
  "New playlist": "قائمة جديدة",
  "Remove from this playlist": "إزالة من هذه القائمة",
  Songs: "أغاني",
  Playlists: "قوائم",
  Name: "الإسم",
  Photo: "الصورة",
  "No playlists": "لا توجد قوائم",
  "Welcome to Youka": "مرحبًا بك في يوكا",
  "Search songs online": "استعراض الأغاني على الإنترنت",
  "create.file.title": "إنشاء كاريوكي من ملف",
  "create.file.description":
    "قم بتحميل ملف MP3 أو MP4 أو غيرها لإنشاء فيديو كاريوكي مع كلمات متزامنة على الفور.",
  "create.online.title": "إنشاء كاريوكي من الأغاني عبر الإنترنت",
  "create.online.description":
    "ابحث عن الأغاني عبر الإنترنت أو الصق رابط الأغنية لإنشاء فيديو كاريوكي مع كلمات متزامنة على الفور.",
  "Change Background": "تغيير الخلفية",
  "Duet Line Split": "تقسيم الخط للدويت",
  Both: "كلاهما",
  Custom: "مخصص",
  Edited: "تم التعديل",
  Trimmed: "تم القص",
  Instrumental: "موسيقى",
  "Add Subword": "إضافة كلمة جزئية",
  "plugins.max_chars.title": "الحد الأقصى للأحرف لكل سط",
  "plugins.max_chars.description": "حدد عدد الأحرف لكل سطر",
  Limit: "الحد",
  "Background Box": "صندوق الخلفية",
  Height: "الارتفاع",
  Width: "العرض",
  Alpha: "الشفافية",
  Color: "اللون",
  Duplicate: "تكرار",
  "Convert to 16x9": "تحويل إلى 16x9",
  "Resize Video": "تغيير حجم الفيديو",
  "Line Alignment": "محاذاة السطر",
  "Shadow Color": "لون الظل",
  "Outline Color": "لون الخط",
  "Active Color": "لون الفعال",
  "Secondary Color": "لون ثانوي",
  "Primary Color": "لون رئيسي",
  "Auto Alignment": "محاذاة مؤقتة",
  "Auto Color": "لون مؤقت",
  "Singer 1": "مغني 1",
  "Singer 2": "مغني 2",
  "Top Row": "الصف العلوي",
  "Bottom Row": "الصف السفلي",
  "Border Style": "أنماط الحدود",
  "Font Name": "اسم الخط",
  "Experimental Subtitles Display": "عرض الترجمات التجريبية",
  Position: "الموضع",
  "Timing Indicator": "عداد التوقيت",
  General: "عام",
  Styles: "أساليب",
  Thumbnail: "صورة أغنية",
  "create.url.title": "إنشاء كاريوكي من رابط",
  "create.url.description": "إنشاء كاريوكي من رابط يدعمه yt-dlp",
  "Paste a URL or start typing to search":
    "قم بالصق رابط أو ابدأ الكتابة للبحث",
  Top: "العلوي",
  Bottom: "السفلي",
  Center: "المركزي",
  "Auto Line Break": "تقسيم السطر تلقائيًا",
  "Fill Color": "لون التعبئة",
  "Active Line Color": "لون السطر الفعال",
  "Waiting Line Color": "لون السطر المنتظر",
  "Set as Default": "تعيين كصورة أفتراضية",
  Default: "أفتراضي",
  "Make Default": "تعيين كافتراضي",
  Image: "الصورة",
  Pause: "توقف",
  File: "الملف",
  "Debug Info": "معلومات التسليم",
  "File Type": "نوع الملف",
  Language: "اللغة",
  "Reset Settings": "إعادة تعيين الإعدادات",
  "Failed to start Youka": "فشل بدء يوكا",
  Legacy: "تقديمي",
  Transcription: "الترجمة",
  Alignment: "المحاذاة",
  Imported: "مستورد",
  "With Backing Vocals": "مع الصوتيات",
  Stem: "الأصوات",
  Clear: "مسح",
  "Open Directory": "فتح المجلد",
  "Advanced Settings": "إعدادات متقدمة",
  "How to Add a Background Black Box to Subtitles":
    "كيفية إضافة مربع أسود خلفي إلى الترجمة",
  "How to Adjust the Line Length": "كيفية ضبط طول السطر",
  "How to Cancel Your Subscription": "كيفية إلغاء اشتراكك",
  "How to Center Subtitles": "كيفية توسيط الترجمة",
  "How to Delete a Karaoke": "كيفية حذف الكاريوكي",
  "How to Edit the lyrics": "كيفية تعديل كلمات الأغاني",
  "How to Fix the Sync": "كيفية إصلاح التزامن",
  "How to Keep Choirs": "كيفية الاحتفاظ بالكورال",
  "How to Keep the Original Singer’s Voice":
    "كيفية الاحتفاظ بصوت المغني الأصلي",
  "How to Set Up a Duet": "كيفية إعداد دويتو",
  "How to Speed Up the Download Process": "كيفية تسريع عملية التنزيل",
  "How to Transfer Your Karaoke Library to a New Computer":
    "كيفية نقل مكتبة الكاريوكي إلى جهاز كمبيوتر جديد",
  "How to Trim a Karaoke Video": "كيفية قص فيديو الكاريوكي",
  FAQ: "الأسئلة الشائعة",
  "library.description":
    "الوصول إلى جميع مسارات الكاريوكي التي أنشأتها وإدارتها. قم بتعديل مشاريعك وتنظيمها وتحسينها.",
  "How to Change the Background Video": "كيفية تغيير فيديو الخلفية",
  "Auto Size": "تلقائي",
  "dialogs.global.no_credits.title": "لا يوجد باقات",
  "dialogs.global.no_credits.description": "يرجى تحديث الباقة للاستمرار",
  "Credits are over! Click to buy more": "انتهت الأرصدة! انقر لشراء المزيد",
  "How to Add a Line Break": "كيفية إضافة عمود جديد",
  "dialogs.global.no_user.many_emails_description":
    "تم حظر الوصول بسبب تسجيل الدخول المتعدد باستخدام عناوين بريد إلكتروني مختلفة. يرجى شراء اشتراك للمتابعة.",
  "dialogs.global.no_user.virtual_machine_description":
    "تم حظر الوصول لأنك تستخدم جهازًا افتراضيًا. للوصول إلى النسخة التجريبية المجانية، يرجى تثبيت Youka على نظام تشغيل عادي. إذا كان لديك اشتراك، يرجى تجديده لاستعادة الوصول. إذا كنت لا تحتاج إلى إنشاء كاريوكي مستمر، يمكنك اختيار خطة الدفع حسب الاستخدام، مما يضمن دفعك فقط عند إنشاء محتوى كاريوكي جديد.",
  "Import Stem": "استيراد الأصوات",
  "Active Outline Color": "لون الخط الفعال",
  "Inactive Outline Color": "لون الخط الغير فعال",
  "Inactive Line Color": "لون السطر الغير فعال",
  "Active Line": "السطر الفعال",
  "Inactive Line": "السطر الغير فعال",
  "End Extra": "الزيادة عند النهاية",
  Expand: "توسيع",
  Collapse: "إلغاء التوسيع",
  "Copy Line": "نسخ السطر",
  "Copy Word": "نسخ الكلمة",
  "Cut Line": "قص السطر",
  "Cut Word": "قص الكلمة",
  "Delete Line": "حذف السطر",
  "Delete Subword": "حذف المقطع الفرعي",
  "Delete Word": "حذف الكلمة",
  "Add Line": "إضافة سطر",
  "Add Word": "إضافة كلمة",
  "Paste Line": "لصق السطر",
  "Paste Word": "لصق الكلمة",
  "Paste Subword": "لصق المقطع الفرعي",
  "Play Line": "تشغيل السطر",
  "Play Word": "تشغيل الكلمة",
  "Select Line": "تحديد السطر",
  "Manual Sync": "مزامنة يدوية",
  "Trim Start": "قص البداية",
  "Trim End": "قص النهاية",
  "Creating will use 1 credit": "الإنشاء سيستهلك رصيدًا واحدًا",
  All: "الكل",
  "Number of Singers": "عدد المغنيين",
  "Style Mapping": "تعيين الأساليب",
  "Associate subtitle styles with singers": "ربط أساليب الترجمة بالمغنيين",
  "Upper first line": "السطر الأول العلوي",
  "Upper second line": "السطر الثاني العلوي",
  "Lower first line": "السطر الأول السفلي",
  "Lower second line": "السطر الثاني السفلي",
  Lock: "قفل",
  "2 Lines": "سطران",
  "4 Lines": "أربعة أسطر",
  Static: "ثابت",
  Dynamic: "ديناميكي",
  "Subtitles Type": "نوع الترجمة",
  "Danger Zone": "المنطقة الخطرة",
  Copy: "نسخ",
  Copied: "تم النسخ",
  "Copy Settings": "نسخ الإعدادات",
  "cta.social.title": "احصل على 50 أرصدة مجانًا!",
  "cta.social.description":
    "شارك منشورًا عن Youka على وسائل التواصل الاجتماعي، وقم بوضع علامة لنا، واحصل على 50 أرصدة مجانية لكل منصة!",
  "cta.social.description.2":
    "اضغط لزيارة صفحة Youka على فيسبوك، أعجب بها، شارك منشورًا، وأرسل بريدك الإلكتروني في الدردشة للحصول على 50 أرصدة مجانية!",
  "Merge Line": "دمج السطر",
  Player: "مشغل",
  "Key Step": "خطوة النغمة",
  "Tempo Step": "خطوة الإيقاع",
  "Shift Line Forward": "تحريك السطر للأمام",
  "Shift Line Backward": "تحريك السطر للخلف",
  "create.description":
    "إنشاء كاريوكي من ملفات الصوت أو الفيديو (MP3، MP4 والمزيد)، أو قم بلصق رابط لإنشاء فيديو كاريوكي مع كلمات متزامنة على الفور.",
  "No file chosen": "لا يوجد ملف مختار",
  "Choose File": "اختيار ملف",
  "Watch Quick Start Video": "شاهد فيديو البدء السريع",
  "Export Settings": "تصدير الإعدادات",
  "Import Settings": "استيراد الإعدادات",
  "Video Guides": "الدلائل المرئية",
  "Quick Start Guide": "دليل البدء السريع",
  "Lyrics Sync Guide": "دليل التزامن الكلمات",
  Resolution: "الدقة",
  "Subtitles Preset": "إعدادات الترجمة",
  Preset: "الإعداد المسبق",
  Done: "تم",
  "New Style Mapping": "تعيين نمط جديد",
  Horizontal: "أفقي",
  Vertical: "عمودي",
  Square: "مربع",
  New: "جديد",
  "New Subtitles Preset": "إعداد مسبق جديد للترجمة",
  "Change Aspect Ratio": "تغيير نسبة العرض إلى الارتفاع",
  "copyright.title.a": "أنا أوافق على",
  "copyright.title.b": "تأكيد استخدام الموسيقى",
  "copyright.description":
    "بتحديد هذا المربع، فإنك تؤكد أنك (A) تمتلك جميع حقوق الموسيقى المدرجة في هذا الفيديو؛ أو (B) أن الموسيقى ضمن الملكية العامة؛ أو (C) لديك إذن من جميع أصحاب الحقوق اللازمين لاستخدام الموسيقى على منصة Youka.",
  "Add Intro Video": "إضافة فيديو تمهيدي",
  "dialogs.intro.description": "أضف فيديو مخصصًا إلى بداية الكاريوكي",
  Transition: "انتقال",
  Fade: "تلاشي",
  "Circle Open": "فتح دائرة",
  "Circle Close": "إغلاق دائرة",
  "Diagonal Open": "فتح قطري",
  "Diagonal Close": "إغلاق قطري",
  "Smooth Left": "انتقال سلس لليسار",
  "Smooth Right": "انتقال سلس لليمين",
  Squares: "مربعات",
  Dissolve: "اندماج",
  Type: "النوع",
  "Song Title": "عنوان الأغنية",
  Artists: "المغنيين",
  Artist: "المغني",
  "Parse Titles": "تحليل عنوان الأغنية",
  "sort.artist.asc": "المغني (أ - ز)",
  "sort.artist.desc": "المغني (ز - أ)",
  "Title Style": "أسلوب العنوان",
  "Artist Style": "أسلوب المغني",
  "Analyse Library": "تحليل المكتبة",
  Key: "المقام",
  "No Filter": "لا يوجد صنف",
  "credits.message_one": "سيستهلك {{count }} رصيد",
  "credits.message_other": "سيستهلك {{count}} رصيد",
  "credits.badge_one": "{{count}} رصيد",
  "credits.badge_other": "{{count}} رصيد",
  "Provide song lyrics to save credits": "أرسل كلمات الأغاني لتوفير رصيد",
  "Upload to Cloud Library": "رفع إلى مكتبة السحابة",
  "Cloud Library": "مكتبة السحابة",
  "Open Cloud Library": "فتح مكتبة السحابة",
};
